export const translations = {
	'There was an error loading dashboard': {},
	'Duplicate dashboard': {
		no: 'Dupliser dashboard',
	},
};
